import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Constants } from '@app/constants';
import {
  IFiProducts,
  patchProductDisplayNames
} from '@app/models/fi-products.model';
import * as _ from 'lodash';
import { forkJoin, Observable } from 'rxjs';
import { concatMap, map, shareReplay } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class FiProductsService {
  private fiProducts$: Observable<IFiProducts>;

  constructor(private http: HttpClient) { }

  getFiProducts({ AccountId }): Observable<IFiProducts> {
    if (!this.fiProducts$) {
      this.fiProducts$ = this.http
        .get<IFiProducts>(
          `${Constants.appConfiguration.apiRoot}/Products/${AccountId}`
        )
        .pipe(
          map(products => {
            patchProductDisplayNames(products);
            return products;
          }),
          shareReplay(1)
        );
    }

    return this.fiProducts$;
  }

  downloadFile(url) {
    return this.http.get(url, { responseType: 'blob' }).pipe(
      map((res: Blob) => {
        return new Blob([res], { type: 'application/pdf' });
      })
    );
  }

  getBrochures(AccountId, productTypes): Observable<any> {
    return this.getFiProducts({ AccountId }).pipe(
      map(products => {
        return _.chain(products)
          .filter((p, key) => _.includes(productTypes, key))
          .map('carrierBrochure')
          .value();
      }),
      concatMap(brochureUrls => {
        const brochurePdf$ = brochureUrls.map(url => this.downloadFile(url));
        return forkJoin(brochurePdf$);
      })
    );
  }
}
